import { render, staticRenderFns } from "./school_AI_frequency.vue?vue&type=template&id=34f3d640&scoped=true"
import script from "./school_AI_frequency.vue?vue&type=script&lang=ts"
export * from "./school_AI_frequency.vue?vue&type=script&lang=ts"
import style0 from "./school_AI_frequency.vue?vue&type=style&index=0&id=34f3d640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f3d640",
  null
  
)

export default component.exports